import { defineComponent as _defineComponent } from 'vue'
import useAvailability from '@/mixins/useAvailability';
import { AvailabilityInterface } from '@/models/Availability';
import { computed, PropType, toRefs } from 'vue';
import useAvailabilityState from '@/state/availabilityState';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvailability',
  props: {
  availability: {
    type: [Object, String] as PropType<AvailabilityInterface | 'store'>,
    default: null
  },
},
  setup(__props) {

const props = __props;




const { availability } = toRefs(props);

const { availability: availabilityState } = useAvailabilityState();

const displayedAvailability = computed(() => {
  if (availability.value === 'store') return availabilityState.value;
  return availability.value;
});

const { mode, when, label } = useAvailability(displayedAvailability);


return { __sfc: true,props, availability, availabilityState, displayedAvailability, mode, when, label }
}

})